import { beginTask, endTask } from 'redux-nprogress';
import { pick, isEqual } from 'lodash';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { selectCurrent } from '../../../../store/reducers/season';
import { selectFormulasState } from '../../../../store/reducers/formula';
import {
  selectPositionsState,
} from '../../../../store/reducers/positions';
import viewNames from '../../../../store/actions/view.types';
import routes from '../../../routes.global';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'StrengthOfSchedule';
export const selectStrengthOfScheduleState = state => state[STORE_KEY];

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  stats: [],
  year: null,
  position: '',
  calcStart: null,
  calcEnd: null,
  showStart: null,
  showEnd: null,
  formulaId: 1,
  hasLoaded: false,
  error: null,
};

const strengthOfScheduleReducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default strengthOfScheduleReducer;

// ------------------------------------
// Actions
// ------------------------------------
export const LOAD_SOS_REQUEST = `${STORE_KEY}/LOAD_SOS_REQUEST`;
export const LOAD_SOS_SUCCESS = `${STORE_KEY}/LOAD_SOS_SUCCESS`;
export const LOAD_SOS_ERROR = `${STORE_KEY}/LOAD_SOS_ERROR`;
export const SET_SOS_SHOWRANGE = `${STORE_KEY}/SET_SOS_SHOWRANGE`;

export const loadStrengthOfScheduleRequest = ({
  year,
  formulaId,
  position,
  calcStart,
  calcEnd,
  showStart,
  showEnd,
}) => ({
  type: LOAD_SOS_REQUEST,
  payload: {
    year,
    formulaId,
    position,
    calcStart,
    calcEnd,
    showStart,
    showEnd,
  },
});

export const setSOSShowRange = range => ({
  type: SET_SOS_SHOWRANGE,
  payload: { showStart: range.min, showEnd: range.max },
});

export const loadStrengthOfScheduleSuccess = (stats) => ({
  type: LOAD_SOS_SUCCESS,
  payload: { stats },
});
export const loadStrengthOfScheduleError = error => ({
  type: LOAD_SOS_ERROR,
  payload: { error },
});

actions[LOAD_SOS_REQUEST] = (
  state,
  {
    payload: {
      year,
      formulaId,
      position,
      calcStart,
      calcEnd,
      showStart,
      showEnd,
    },
  },
) => ({
  ...state,
  year,
  formulaId,
  position,
  calcStart,
  calcEnd,
  showStart,
  showEnd,
});

actions[LOAD_SOS_SUCCESS] = (state, { payload: { stats } }) => ({
  ...state,
  stats,
  hasLoaded: true,
});

actions[LOAD_SOS_ERROR] = (state, { payload }) => ({
  ...state,
  error: payload.error,
});

actions[SET_SOS_SHOWRANGE] = (state, { payload }) => ({
  ...state,
  ...payload,
});

export const loadStrengthOfSchedule = params => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    const sosState = selectStrengthOfScheduleState(getState());
    const oldParams = pick(sosState, ['position', 'formulaId', 'year', 'calcStart', 'calcEnd']);
    dispatch(
      loadStrengthOfScheduleRequest(params),
    );
    // Only do API call if these parameters change or data hasn't loaded
    const newParams = pick(params, ['position', 'formulaId', 'year', 'calcStart', 'calcEnd']);
    if (!isEqual(newParams, oldParams) || !sosState.hasLoaded) {
      const response = await api.stats.getStrengthOfSchedule(params);
      dispatch(loadStrengthOfScheduleSuccess(response.strength_of_schedule));
    }
  } catch (error) {
    console.error(error);
    dispatch(loadStrengthOfScheduleError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View / Route
// ------------------------------------
export const SOS_VIEW = `${STORE_KEY}/SOS_VIEW`;
viewNames[SOS_VIEW] = 'StrengthOfSchedule';
routes[SOS_VIEW] = {
  path: '/stats/strength-of-schedule',
  thunk: async (dispatch, getState) => {
    const state = getState();
    let {
      year,
      formulaId,
      calcStart,
      calcEnd,
      position,
    } = selectQuery(state);
    let { showStart, showEnd } = selectStrengthOfScheduleState(getState());
    const currentWeek = selectCurrent(state, 'stats').week;
    if (!formulaId) formulaId = selectFormulasState(state).defaultFormula;
    if (year === null || year === undefined || year === 'null') year = selectCurrent(state, 'stats').season;
    if (!position) position = selectPositionsState(state).stats[0];
    if (!calcStart) calcStart = 1;
    if (!calcEnd) calcEnd = (currentWeek >= 17) ? (year <= 2020 ? 17 : 18) : currentWeek;
    if (!showStart) showStart = (currentWeek < 17) ? currentWeek : 1;
    if (!showEnd) showEnd = year <= 2020 ? 17 : 18;
    // Return sliders end to 17
    if (year <= 2020 && showEnd > 17) showEnd = 17;
    if (year <= 2020 && calcEnd > 17) calcEnd = 17;

    // Return sliders end to 17
    if (year <= 2020 && showEnd > 17) showEnd = 17;
    if (year <= 2020 && calcEnd > 17) calcEnd = 17;

    await dispatch(
      loadStrengthOfSchedule({
        year,
        formulaId,
        calcStart,
        calcEnd,
        showStart,
        showEnd,
        position,
      }),
    );
    await dispatch(loadToolDescriptions());
  },
};



// WEBPACK FOOTER //
// ./src/app/views/StrengthOfSchedule/module/strengthOfSchedule.js